<div class="wrapper-promotions">
    <div class="section-text row">
        <div class="section-btn">
            <button class="btn btn-back rounded-circle mt-2" routerLink="/dashboard/email-template">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <h1 class="title">Email Setting</h1>
        </div>
    </div>

    <div class="section-main">
        <div class="table-stores table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="text-center">
                            Category
                        </th>
                        <th class="text-center">
                            Email Template
                        </th>
                        <th class="text-center">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="templates?.length == 0 && !loading">
                        <td colspan="8" class="border-left-0 border-right-0 pb-4 text-center no-records">No Record found</td>
                    </tr>
                    <tr *ngIf="loading">
                        <td class="border-left-0 border-right-0 pb-4 text-center" colspan="8">
                            <div class="loading-spinner col-12">
                                <mat-spinner
                                  class="mx-auto my-3"
                                  [diameter]="50"
                                ></mat-spinner>
                              </div>
                        </td>
                    </tr>
                    <!-- <tr *ngFor="let p of templates">
                        <td>
                            
                            <span class="ml-2">{{ p.category }}</span>
                        </td>
                        <td class="text-center">{{ p.template_name }}
                            <img width="40" [src]="p.image">
                            
                        </td>
                       
                        <td class="d-flex justify-content-center mb-3">
                            <div>
                                <button (click)="open(content, p.template_id)" class="btn btn-red-small btn-sm">Delete</button>
                            </div>
                        </td>
                    </tr> -->

                    <tr>
                        <td>
                            
                            <span class="ml-2">Order</span>
                        </td>
                        <td class="text-center"> Email Default 1
                            <img width="40" src="https://estore-images.s3.ap-southeast-1.amazonaws.com/dealers/store1029_media309.jpg">
                            
                        </td>
                       
                        <td class="d-flex justify-content-center mb-3">
                            <div>
                                <!-- (click)="open(content, p.template_id)" -->
                                <button  class="btn btn-blue-small btn-sm">Edit</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Delete Discount</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="text-secondary">Are you sure you want to delete this Discount?</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="modal.close('Save click')">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="successModal(success);modal.close('delete')">Delete</button>
    </div>
</ng-template>

<ng-template #success let-modal>
    <div class="modal-body text-center">
        <div class="row" align="center" >
            <div class="col pt-4 pt-lg-0">
                <h4>Successfully Update</h4>
            </div>
        </div>
        <button  class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')  ">Close</button>
    </div>
</ng-template>